var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv5-multiline-slide-grid-h",style:(_vm.style)},[_vm._t("default",_vm._l((_vm.example),function(card,index){return _c('div',{key:index},[_vm._v(_vm._s(card))])}))],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ed7c99","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/dashboard-v5/shared/MultilineSlideGridH.vue
// module id = vzkz
// module chunks = 0